// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slick-next:before,.slick-prev:before{color:#000!important}.custom-select-arrow{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%237e7e7e' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M5.516 7.548L10 12.035l4.484-4.487'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 1rem center;background-size:1.5rem;padding-right:2.5rem}select::-ms-expand{display:none}", ""]);
// Exports
module.exports = exports;
